export default [
    {
        path: '/indication',
        name: 'indication',
        component: () => import ('./pages/Index')
    }
]